import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TABLE_VIEW_MODES } from 'src/app/extensions/constants/commonConstants';
import { RESPONSIVE_BREAKPOINTS } from 'src/app/extensions/constants/responsive-breakpoints';
import { InsuranceAPIService } from 'src/app/extensions/services/api/insurance-api.service';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { ScrollService } from 'src/app/extensions/services/scroll.service';
import { WindowEventsService } from 'src/app/extensions/services/window-events.services';
import { scrollTop, setTableViewMode } from 'src/app/extensions/utilities';

@Component({
  selector: 'insurances-list',
  standalone: false,
  templateUrl: './insurances-list.component.html',
  styleUrl: './insurances-list.component.scss',
  providers: [ScrollService],
})
export class InsurancesListComponent implements OnInit, OnDestroy {
  public showBackToTop = false;
  public TABLE_VIEW_MODES = TABLE_VIEW_MODES;
  public currentRoute: string;
  public tableViewMode: string;
  public hasData = true;
  public props: app.models.DynamicPropsDictionary;
  private pageIndex = 1;
  private pageFilter: app.models.GetPagedInsurancesFilterModel;
  public subscriptions: Subscription[] = [];
  public windowSizeLgUp = true;
  public insurances: app.models.InsuranceModel[];
  private maxIndex: number;

  constructor(
    public _globalService: GlobalService,
    private _insuranceApiService: InsuranceAPIService,
    private _router: Router,
    private _scrollService: ScrollService,
    private _windowEventService: WindowEventsService
  ) {
    this.currentRoute = this._router.url.split('/')[1];
  }

  ngOnInit(): void {
    this.tableViewMode = setTableViewMode(this._globalService, this.currentRoute);
    this.pageFilter = {
      startDate: null,
      endDate: null,
    };
    this.loadData();
    let backToTopSubscription = this._scrollService.obsShowBackToTop.subscribe(x => {
      this.showBackToTop = x;
    });
    this.subscriptions.push(backToTopSubscription);

    let scrollSubscription = this._scrollService.obsFetchData.subscribe(() => {
      if (this.pageIndex <= this.maxIndex) {
        this.pageIndex++;
        this._insuranceApiService.getPagedInsurances(this.pageIndex, this.pageFilter).subscribe(x => {
          this.insurances = this.insurances.concat(x.data.values);
          if (this.pageIndex <= this.maxIndex) {
            this._scrollService.waitingForDataFetch = false;
          }
        });
      }
    });
    this.subscriptions.push(scrollSubscription);

    this.windowSizeLgUp = window.innerWidth >= RESPONSIVE_BREAKPOINTS.lg;
    let resizeSubscription = this._windowEventService.onResize.subscribe(() => {
      this.windowSizeLgUp = window.innerWidth >= RESPONSIVE_BREAKPOINTS.lg;
    });
    this.subscriptions.push(resizeSubscription);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  loadData() {
    this._insuranceApiService.getPagedInsurances(this.pageIndex, this.pageFilter).subscribe(res => {
      this.insurances = res.data.values;
      this.hasData = this.insurances.length != 0;
      this.props = res.props;
      this.maxIndex = res.data.totalPages;

      this._scrollService.waitingForDataFetch = this.pageIndex > this.maxIndex;
    });
  }

  public toggleViewMode(tableViewMode: string) {
    this.tableViewMode = tableViewMode;
    this._globalService.toggleTableViewMode(this.currentRoute, tableViewMode);
  }

  scrollToTop(): void {
    scrollTop();
  }
}
